import { render } from "./ShopGz.vue?vue&type=template&id=18f18f04&scoped=true"
import script from "./ShopGz.vue?vue&type=script&lang=js"
export * from "./ShopGz.vue?vue&type=script&lang=js"

import "./ShopGz.vue?vue&type=style&index=0&id=18f18f04&scoped=true&lang=scss"
import "./ShopGz.vue?vue&type=style&index=1&id=18f18f04&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f18f04"]])

export default __exports__